export const chapter4Translations = {
  name: "Capitolo 4: Crocifissione e Risurrezione",
  description: "Segui la storia della passione, morte e risurrezione di Gesù",
  spiritualWisdom: "La croce è il simbolo del trionfo definitivo dell'amore e della vittoria sul peccato. La risurrezione ci offre la promessa di una nuova vita in Cristo.",
  
  levels: {
    40: {
      name: "L'Arresto",
      challenge: "Scopri l'arresto di Gesù nel Getsemani",
      
      questions: {
        easy: {
          question: "In quale giardino fu arrestato Gesù?",
          options: ["Getsemani", "Eden", "Ulivi", "Nazaret"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "Quale segno usò Giuda per tradire Gesù?",
          options: ["Una stretta di mano", "Un bacio", "Una parola", "Un gesto"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Quale discepolo tagliò l'orecchio del servo del sommo sacerdote con la sua spada?",
          options: ["Giacomo", "Giovanni", "Pietro", "Andrea"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Getsemani è un giardino ai piedi del Monte degli Ulivi",
        "Giuda tradì Gesù per 30 monete d'argento",
        "Gesù guarì miracolosamente l'orecchio del servo"
      ],
      
      funFacts: [
        "Getsemani significa 'frantoio', dove si produceva l'olio d'oliva",
        "L'arresto di Gesù avvenne nel cuore della notte",
        "Gesù andò pacificamente, chiedendo ai suoi discepoli di non resistere con violenza"
      ]
    },

    41: {
      name: "Il Rinnegamento di Pietro",
      challenge: "Scopri come Pietro rinnegò Gesù tre volte",
      
      questions: {
        easy: {
          question: "Quante volte Pietro rinnegò Gesù?",
          options: ["Una volta", "Due volte", "Tre volte", "Quattro volte"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Cosa accadde dopo il terzo rinnegamento di Pietro?",
          options: ["Sorse il sole", "Cantò il gallo", "Lampeggiò un fulmine", "Ci fu un terremoto"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Dove si trovava Pietro quando rinnegò Gesù?",
          options: ["Nel tempio", "Nel cortile del sommo sacerdote", "Nel palazzo di Pilato", "A Getsemani"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Gesù aveva predetto il rinnegamento di Pietro",
        "Pietro pianse amaramente dopo aver realizzato ciò che aveva fatto",
        "Tutto accadde nella stessa notte"
      ],
      
      funFacts: [
        "Gesù disse 'Prima che il gallo canti, tu mi rinnegherai tre volte'",
        "Il rinnegamento di Pietro è un esempio potente della debolezza umana e del perdono divino",
        "Pietro divenne in seguito un grande leader della Chiesa"
      ]
    },

    42: {
      name: "Gesù davanti a Pilato",
      challenge: "Scopri il processo di Gesù davanti al governatore romano",
      
      questions: {
        easy: {
          question: "Chi era Pilato?",
          options: ["Un discepolo", "Il governatore romano", "Il sommo sacerdote", "Un fariseo"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Cosa non trovò Pilato in Gesù?",
          options: ["Saggezza", "Colpa", "Coraggio", "Potere"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Cosa fece Pilato per simboleggiare la sua innocenza?",
          options: ["Si lavò le mani", "Strappò la sua veste", "Digiunò", "Pregò"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Pilato voleva rilasciare Gesù",
        "La folla chiedeva la crocifissione di Gesù",
        "Pilato cedette alla pressione politica"
      ],
      
      funFacts: [
        "La moglie di Pilato lo avvertì di non fare nulla contro Gesù",
        "Lavarsi le mani era un simbolo di innocenza nella tradizione ebraica",
        "La decisione di Pilato dimostrò il fallimento della giustizia umana"
      ]
    },

    43: {
      name: "Barabba o Gesù",
      challenge: "Scopri la scelta della folla per Barabba",
      
      questions: {
        easy: {
          question: "Chi era Barabba?",
          options: ["Un discepolo", "Un brigante", "Un sacerdote", "Un re"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Cosa poteva fare Pilato durante la festa ebraica?",
          options: ["Liberare un prigioniero", "Perdonare le tasse", "Offrire un banchetto", "Chiudere il tempio"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Chi scelse la folla?",
          options: ["Gesù", "Barabba", "Entrambi", "Nessuno"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Era la festa della Pasqua",
        "La folla chiese che Gesù fosse crocifisso",
        "Barabba era un assassino e un ribelle"
      ],
      
      funFacts: [
        "Il nome Barabba significa 'figlio del padre'",
        "La liberazione di Barabba è un simbolo del sacrificio di Cristo",
        "Siamo tutti Barabba, liberati dal sacrificio di Gesù"
      ]
    },

    44: {
      name: "Flagellazione e Corona di Spine",
      challenge: "Scopri la sofferenza di Gesù",
      
      questions: {
        easy: {
          question: "Cosa misero i soldati sulla testa di Gesù?",
          options: ["Una corona d'oro", "Una corona di spine", "Una ghirlanda di fiori", "Un turbante"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Come derisero i soldati Gesù?",
          options: ["Chiamandolo re", "Lapidandolo", "Mettendolo in prigione", "Ignorandolo"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Cosa conteneva la frusta romana?",
          options: ["Strisce di cuoio", "Pezzi di osso e metallo", "Solo legno", "Corda"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "La flagellazione era una punizione romana brutale",
        "I soldati vestirono Gesù con un mantello purpureo",
        "Gesù sopportò tutto questo in silenzio"
      ],
      
      funFacts: [
        "La corona di spine simboleggia la maledizione del peccato",
        "Il colore purpureo era un colore regale, usato per scherno",
        "La sofferenza di Gesù adempie le profezie di Isaia"
      ]
    },

    45: {
      name: "Via verso il Golgota",
      challenge: "Scopri come Gesù portò la croce",
      
      questions: {
        easy: {
          question: "Cosa portò Gesù?",
          options: ["Una bandiera", "Una croce", "Una corona", "Una spada"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Chi aiutò Gesù a portare la croce?",
          options: ["Pietro", "Giovanni", "Simone di Cirene", "Giuseppe"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Cosa significa Golgota?",
          options: ["Monte santo", "Luogo del cranio", "Luogo di pace", "Luogo di giustizia"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Gesù cadde diverse volte per la debolezza",
        "Le donne piangevano lungo il cammino",
        "La processione attraversò la città"
      ],
      
      funFacts: [
        "La croce pesava circa 40-50 kg",
        "Golgota si trovava fuori dalle mura della città",
        "Simone di Cirene veniva dall'Africa"
      ]
    },

    46: {
      name: "La Crocifissione",
      challenge: "Scopri la crocifissione di Gesù",
      
      questions: {
        easy: {
          question: "Con quante altre persone fu crocifisso Gesù?",
          options: ["Nessuna", "Una", "Due", "Tre"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Cosa disse Gesù sulla croce: 'Padre, ___ loro'?",
          options: ["Salva", "Perdona", "Ferma", "Punisci"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Qual era l'iscrizione sulla croce?",
          options: ["Peccatore", "Re dei Giudei", "Ribelle", "Profeta"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Gesù fu crocifisso alla terza ora del giorno",
        "I soldati tirarono a sorte per le sue vesti",
        "Gesù pronunciò sette parole dalla croce"
      ],
      
      funFacts: [
        "L'iscrizione era scritta in tre lingue: ebraico, latino e greco",
        "Uno dei ladroni si pentì all'ultimo momento",
        "Gesù affidò sua madre alle cure di Giovanni"
      ]
    },

    47: {
      name: "La Morte di Gesù",
      challenge: "Scopri le ultime ore di Gesù",
      
      questions: {
        easy: {
          question: "Cosa accadde al momento della morte di Gesù?",
          options: ["Il sole brillò più forte", "Si fece buio", "Piovve", "Apparve un arcobaleno"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Cosa si squarciò nel tempio?",
          options: ["Il pavimento", "Il velo", "Il muro", "Il tetto"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Quali furono le ultime parole di Gesù?",
          options: ["È compiuto", "Ho sete", "Padre, nelle tue mani affido il mio spirito", "Perché mi hai abbandonato"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "L'oscurità durò tre ore",
        "Un soldato trafisse il fianco di Gesù con una lancia",
        "Un centurione disse 'Veramente quest'uomo era Figlio di Dio'"
      ],
      
      funFacts: [
        "Il velo del tempio si squarciò dall'alto in basso, non per mano umana",
        "Questo avvenne durante la Pasqua, quando veniva sacrificato l'agnello",
        "La morte di Gesù pagò il salario del peccato"
      ]
    },

    48: {
      name: "La Sepoltura",
      challenge: "Scopri la sepoltura di Gesù",
      
      questions: {
        easy: {
          question: "Nel sepolcro di chi fu posto Gesù?",
          options: ["Pietro", "Giuseppe d'Arimatea", "Nicodemo", "Lazzaro"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "In cosa fu avvolto il corpo di Gesù?",
          options: ["In un mantello purpureo", "In vesti dorate", "In un lenzuolo bianco", "Senza vesti"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Cosa portò Nicodemo per il corpo di Gesù?",
          options: ["Olio", "Mirra e aloe", "Acqua", "Fiori"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "La tomba era scavata in una roccia nuova",
        "Una grande pietra fu rotolata per chiudere l'ingresso",
        "Furono poste guardie a sorvegliare il sepolcro"
      ],
      
      funFacts: [
        "Era il sepolcro di un uomo ricco, adempiendo la profezia di Isaia",
        "La sepoltura fu fatta in fretta perché stava arrivando il sabato",
        "Giuseppe era un discepolo segreto che divenne coraggioso"
      ]
    },

    49: {
      name: "Il Sepolcro Vuoto",
      challenge: "Scopri la scoperta della mattina di Pasqua",
      
      questions: {
        easy: {
          question: "Chi trovò per primo il sepolcro vuoto?",
          options: ["Pietro", "Giovanni", "Le donne", "I soldati"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Dov'era la pietra?",
          options: ["Rotta", "Rotolata via", "Ancora lì", "Sparita"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Quanti angeli trovarono le donne nel sepolcro?",
          options: ["Nessuno", "Uno", "Due", "Tre"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Era la mattina del primo giorno della settimana",
        "Le donne vennero per ungere il corpo di Gesù",
        "Gli angeli annunciarono la buona notizia"
      ],
      
      funFacts: [
        "Le donne furono le prime testimoni, un dettaglio rivoluzionario",
        "Pietro e Giovanni corsero al sepolcro",
        "Il sepolcro vuoto da solo non bastava, Gesù doveva apparire"
      ]
    },

    50: {
      name: "Gesù Appare a Maria Maddalena",
      challenge: "Scopri la prima apparizione di Gesù",
      
      questions: {
        easy: {
          question: "A chi apparve per primo Gesù dopo la risurrezione?",
          options: ["Pietro", "Giovanni", "Maria Maddalena", "Tommaso"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Per chi scambiò inizialmente Maria Gesù?",
          options: ["Un angelo", "Il giardiniere", "Un soldato", "Un fariseo"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Cosa disse Gesù a Maria quando lo riconobbe?",
          options: ["Va' e annuncia", "Non mi trattenere", "Non temere", "Credi"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Maria stava piangendo vicino al sepolcro",
        "Gesù la chiamò per nome",
        "La mandò ad annunciarlo ai suoi fratelli"
      ],
      
      funFacts: [
        "Gesù scelse una donna per la sua prima apparizione",
        "Maria divenne la prima apostola",
        "Lo chiamò 'Rabboni' (Maestro)"
      ]
    },

    51: {
      name: "Sulla Via di Emmaus",
      challenge: "Scopri l'apparizione di Gesù sulla strada",
      
      questions: {
        easy: {
          question: "Quanti discepoli stavano andando a Emmaus?",
          options: ["Uno", "Due", "Tre", "Quattro"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Quando i discepoli riconobbero Gesù?",
          options: ["Immediatamente", "Allo spezzare del pane", "Sulla strada", "Mai"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Cosa spiegò loro Gesù lungo la strada?",
          options: ["Il futuro", "Le Scritture", "La legge", "I miracoli"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Gesù camminò con loro come uno straniero",
        "I loro cuori ardevano mentre parlava",
        "Gesù sparì quando lo riconobbero"
      ],
      
      funFacts: [
        "Emmaus distava circa 11 km da Gerusalemme",
        "Gesù mostrò loro come tutte le Scritture parlavano di lui",
        "I discepoli tornarono immediatamente a Gerusalemme di corsa"
      ]
    },

    52: {
      name: "L'Apparizione ai Discepoli",
      challenge: "Scopri l'apparizione di Gesù nella stanza chiusa",
      
      questions: {
        easy: {
          question: "Dove si trovavano i discepoli quando Gesù apparve?",
          options: ["Nel tempio", "Al mercato", "In una stanza chiusa", "A Getsemani"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Cosa mostrò Gesù ai discepoli?",
          options: ["Le sue ferite", "Il suo volto", "Le sue vesti", "Una luce"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Quale discepolo era assente la prima volta?",
          options: ["Pietro", "Giovanni", "Tommaso", "Giacomo"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Le porte erano chiuse per paura",
        "Gesù disse 'Pace a voi'",
        "Soffiò su di loro e disse 'Ricevete lo Spirito Santo'"
      ],
      
      funFacts: [
        "Gesù mangiò con loro per dimostrare che non era un fantasma",
        "Tommaso credette una settimana dopo",
        "Gesù apparve molte volte per 40 giorni"
      ]
    }
  }
};
